var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLogout = function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    fillRule: "evenodd",
    d: "M5.318 7.227a.563.563 0 0 0-.796 0l-1.92 1.92a.563.563 0 0 0 0 .796l1.92 1.92a.562.562 0 1 0 .796-.796L3.795 9.545l1.523-1.522a.563.563 0 0 0 0-.796Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    fillRule: "evenodd",
    d: "M11.242 9.545a.563.563 0 0 0-.562-.563H3.052a.563.563 0 0 0 0 1.125h7.628c.31 0 .562-.251.562-.562Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    fillRule: "evenodd",
    d: "M13.035 5.502c.965.916 1.582 2.264 1.582 3.998 0 1.734-.617 3.082-1.582 3.998-.969.921-2.325 1.44-3.855 1.44a.562.562 0 1 0 0 1.124c1.784 0 3.428-.606 4.63-1.748 1.207-1.146 1.932-2.798 1.932-4.814s-.725-3.668-1.932-4.814c-1.202-1.142-2.846-1.748-4.63-1.748a.563.563 0 0 0 0 1.124c1.53 0 2.886.519 3.855 1.44Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLogout;